/* -------------------------------------------------------------------------- */
/*                           Schema Sensor Measures                           */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const sensorMeasure = new schema.Entity('sensorMeasures', {}, { idAttribute: 'measureId' });
export const sensorMeasures = new schema.Array(sensorMeasure);
